"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportsStore = void 0;
const api_1 = require("client/api");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const claim_1 = require("shared/claim");
const connect_asset_1 = require("shared/connect-asset");
const util_1 = require("shared/util");
const app_settings_1 = require("shared/app-settings");
const moment = require("moment-timezone");
/** D-002.9101 / FMT-06 — Audit Trail displays all event times in Eastern. */
const AUDIT_TRAIL_TIMEZONE = "America/New_York";
const formatAuditTrailEastern = (rows) => (rows || []).map((row) => {
    if (!row || !row.EventDateTime) {
        return Object.assign(Object.assign({}, row), { EventDate: (row === null || row === void 0 ? void 0 : row.EventDate) || "", EventTime: (row === null || row === void 0 ? void 0 : row.EventTime) || "" });
    }
    const et = moment.tz(row.EventDateTime, AUDIT_TRAIL_TIMEZONE);
    if (!et.isValid()) {
        return Object.assign(Object.assign({}, row), { EventDate: row.EventDate || "", EventTime: row.EventTime || "" });
    }
    return Object.assign(Object.assign({}, row), { EventDate: et.format("MM/DD/YYYY"), EventTime: et.format("hh:mm:ss A") });
});
class ReportsStore {
    constructor() {
        this.claimAnalyticsData = [];
        this.clinicReimbData = [];
        this.orderAnalyticsData = [];
        this.salesUsageSummaryData = [];
        this.negativeBalancesData = [];
        this.accountsReceivableAgingData = [];
        this.auditTrailData = [];
        this.insurancePaymentReportData = [];
        this.inventoryCountData = [];
        this.cycleCountData = [];
        this.reversalsData = [];
        this.erxData = [];
        this.networkContactsData = [];
        this.distibutorAnalyticsData = [];
        this.dispenseReportData = [];
        this.transactionCountsData = [];
        this.certificationsReportData = [];
        this.requiredAssets = [];
        this.editModal = true;
        this.showLoader = false;
        this.certOptionMissing = false;
        this.startDate = ''; //E-017.1
        this.endDate = ''; //E-017.1
        this.patientReportData = []; // E-037.2
        this.patients = {}; // E-037.2
        /** Query Actions */
        this.loadClaimAnalytics = async (siteId = -1, claimStatus = claim_1.ClaimStatus.Dispensed, startDate = "", endDate = "", cashOnly = false, logExecution = false) => {
            this.startDate = startDate; //E-017.1
            this.endDate = endDate; //E-017.1
            this.claimAnalyticsData = [];
            const result = await api_1.ReportsEndpoint.claimAnalytics.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                claimStatus: claimStatus === "0" ? null : claimStatus,
                startDate,
                endDate,
                cashOnly,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.claimAnalyticsData = result.analyticsData;
            }
        };
        this.loadUserAuditTrail = async (searchType = "", userId = store_1.usersStore.user.value.id, rxId = "", siteId = [], patientId = 0, purchaseOrderId = "", startDate = util_1.previousMonth(), endDate = util_1.currentDate(), claimId = "", eventAction = "", //E-055
        eventType = "", //E-055
        categoryReference = "", //E-055
        showDisabledSites = false, // C-123
        logExecution = false) => {
            this.auditTrailData = [];
            const result = await api_1.ReportsEndpoint.userAuditTrail.apiCall(null, {
                searchType,
                userId,
                rxId,
                siteId,
                patientId,
                purchaseOrderId,
                startDate,
                endDate,
                claimId,
                eventAction,
                eventType,
                categoryReference,
                showDisabledSites,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                // D-002.9101 — format EventDate / EventTime in Eastern (like payment history TZ display)
                this.auditTrailData = formatAuditTrailEastern(result.analyticsData);
            }
        };
        this.loadClinicReimbursement = async (siteId = -1, claimStatus = claim_1.ClaimStatus.Dispensed, startDate = "", endDate = "", logExecution = false) => {
            this.clinicReimbData = [];
            const result = await api_1.ReportsEndpoint.clinicReimbursement.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                claimStatus: claimStatus === "0" ? null : claimStatus,
                startDate,
                endDate,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                if (result.analyticsData) {
                    this.clinicReimbData = result.analyticsData;
                }
                // console.log("this clinic reimb data===>", this.clinicReimbData);
            }
        };
        this.loadOrderAnalytics = async (distributor = "", ndc = "", startDate = "", endDate = "", siteId = -1, showDisabledSites = false, logExecution = false) => {
            this.orderAnalyticsData = [];
            const result = await api_1.ReportsEndpoint.orderingAnalytics.apiCall(null, {
                distributor,
                ndc,
                startDate,
                endDate,
                siteId: siteId === 0 ? null : siteId,
                showDisabledSites,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.orderAnalyticsData = result.analyticsData;
            }
        };
        this.loadSalesUsage = async (siteId = -1, searchType = "", distributor = "", ndc = "", startDate = "", endDate = "", logExecution = false) => {
            this.salesUsageSummaryData = [];
            const result = await api_1.ReportsEndpoint.salesUsage.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                searchType,
                distributor,
                ndc,
                startDate,
                endDate,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error loading sales usage summary data.");
            }
            else {
                this.showLoader = false;
                this.salesUsageSummaryData = result.analyticsData;
            }
        };
        this.loadNetworkContacts = async () => {
            this.showLoader = true;
            this.networkContactsData = [];
            const result = await api_1.ReportsEndpoint.networkContacts.apiCall();
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.networkContactsData = result.analyticsData;
            }
        };
        this.loadNegativeBalances = async (siteId = -1, payerName = "", logExecution = false) => {
            this.negativeBalancesData = [];
            const result = await api_1.ReportsEndpoint.negativeBalances.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                payerName,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.negativeBalancesData = result.analyticsData;
            }
        };
        // Should probably move this to order/store.
        this.repairReversals = async (orderId) => {
            const query = {
                name: app_settings_1.AppOption.ERXToJSON,
                value: JSON.stringify({ numbers: { orderId } })
            };
            await api_1.AppSettingsEndpoint.callTrigger.apiCall(null, query);
        };
        this.reportsB2 = async (contentId, isCopay) => {
            const result = await api_1.ReportsEndpoint.reportsB2.apiCall(null, { contentId, isCopay });
            const { success } = result;
            return success;
        };
        this.loadErxReport = async (query) => {
            this.showLoader = true;
            const result = await api_1.ReportsEndpoint.erxReport.apiCall(null, { query });
            this.erxData = result.erxData;
            this.showLoader = false;
        };
        // E-064.51
        this.loadClaimErrorReport = async (query) => {
            this.showLoader = true;
            const result = await api_1.ReportsEndpoint.claimErrorReport.apiCall(null, query);
            this.showLoader = false;
            return api_1.isError(result) ? { code: "Error" } : { claimErrorData: result.output };
        };
        this.loadMailMessage = async (id) => {
            this.showLoader = true;
            const result = await api_1.ReportsEndpoint.readMailMessage.apiCall(null, { id });
            this.showLoader = false;
            return api_1.isError(result) ? { code: "Error" } : result.mailMessage;
        };
        this.loadMailReport = async (query) => {
            this.showLoader = true;
            const result = await api_1.ReportsEndpoint.mailReport.apiCall(null, query);
            this.showLoader = false;
            return api_1.isError(result) ? { code: "Error" } : { mailMessages: result.mailMessages };
        };
        this.loadProductAuditReport = async (query) => {
            this.showLoader = true;
            const result = await api_1.ReportsEndpoint.productAuditReport.apiCall(null, query);
            this.showLoader = false;
            return api_1.isError(result) ? { code: "Error" } : { productAudit: result.output };
        };
        this.loadPatinetPaymentReport = async (query, logExecution = false) => {
            this.showLoader = true;
            const result = await api_1.ReportsEndpoint.patientPaymentReport.apiCall(null, query);
            this.showLoader = false;
            return api_1.isError(result) ? { code: "Error" } : { patientPayments: result.patientPayments };
        };
        this.loadReversalsReport = async (query) => {
            this.showLoader = true;
            const result = await api_1.ReportsEndpoint.reversalsReport.apiCall(null, { query });
            this.reversalsData = result.reversalsData;
            this.showLoader = false;
        };
        this.loadAccountsReceivableAging = async (siteId = -1, startDate = "", endDate = "", logExecution = false) => {
            this.accountsReceivableAgingData = [];
            const result = await api_1.ReportsEndpoint.accountsReceivableAging.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                startDate,
                endDate,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.accountsReceivableAgingData = result.analyticsData;
            }
        };
        this.loadTransactionCounts = async (startDate = "", endDate = "", logExecution = false) => {
            this.transactionCountsData = [];
            const result = await api_1.ReportsEndpoint.transactionCounts.apiCall(null, {
                startDate,
                endDate,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.transactionCountsData = result.analyticsData;
            }
        };
        this.loadCertificationsReport = async (searchType = "", siteId = -1, entity = connect_asset_1.EntityType.all, completionStatus = "", expStatus = "", requiredAsset = -1, logExecution = false) => {
            this.certificationsReportData = [];
            const result = await api_1.ReportsEndpoint.certificationsReport.apiCall(null, {
                searchType,
                siteId: siteId === 0 ? null : siteId,
                entity,
                completionStatus,
                expStatus,
                requiredAsset,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                if (searchType === "missing") {
                    this.certOptionMissing = true;
                }
                else {
                    this.certOptionMissing = false;
                }
                this.certificationsReportData = result.analyticsData;
            }
        };
        this.loadRequiredAssets = async () => {
            this.requiredAssets = [];
            const result = await api_1.ReportsEndpoint.loadRequiredAssets.apiCall();
            if (api_1.isError(result)) {
                alert("Error in loading required assets");
            }
            else {
                this.requiredAssets = result.analyticsData;
            }
        };
        this.loadInsurancePaymentReport = async (
        // claimStatus: ClaimStatus,
        siteId = "-1", startDate = "", endDate = "", logExecution = false) => {
            this.insurancePaymentReportData = [];
            const result = await api_1.ReportsEndpoint.insurancePaymentReport.apiCall(null, {
                // claimStatus,
                siteId: siteId === "0" ? "0" : siteId,
                startDate,
                endDate,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                // console.log(result);
                this.showLoader = false;
                this.insurancePaymentReportData = result.analyticsData;
            }
        };
        this.getDistributors = async () => {
            const result = await api_1.ReportsEndpoint.getDistributors.apiCall();
            if (api_1.isError(result)) {
                alert("Error");
            }
            else {
                this.distributors = result.distributors;
            }
        };
        this.getDistributorOrderingData = async () => {
            this.distibutorAnalyticsData = [];
            const result = await api_1.ReportsEndpoint.getDistributorOrdering.apiCall();
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.distibutorAnalyticsData = result.distributorOrderingData;
            }
        };
        this.loadDispenseReport = async (siteId = -1, startDate = "", endDate = ""
        // siteId: number = usersStore.user.value.siteId,
        // startDate: string = previousMonth(),
        // endDate: string = currentDate()
        ) => {
            this.dispenseReportData = [];
            const result = await api_1.ReportsEndpoint.getDispenseData.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                startDate,
                endDate
            });
            // console.log(result);
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                // console.log(result);
                this.showLoader = false;
                this.dispenseReportData = result.dispenseReportData;
            }
        };
        this.loadInventoryCount = async (siteId = -1, logExecution = false) => {
            this.inventoryCountData = [];
            const result = await api_1.ReportsEndpoint.inventoryCountReport.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.inventoryCountData = result.analyticsData;
            }
        };
        this.loadCycleCount = async (siteId = -1, logExecution = false) => {
            this.cycleCountData = [];
            const result = await api_1.ReportsEndpoint.listcyclecount.apiCall(null, {
                siteId: siteId === 0 ? null : siteId,
                logExecution
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                console.error("Error in loading cycle count", result.code);
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.cycleCountData = result.cycleCountData;
            }
        };
        this.loadPdfZips = async (siteId = -1) => {
            this.cycleCountData = [];
            const result = await api_1.ReportsEndpoint.loadPdfZips.apiCall(null, {
                siteId: siteId === 0 ? null : siteId
            });
            if (api_1.isError(result)) {
                console.error("Error loading pdf zips", result.code);
            }
            else {
                return result.results;
            }
        };
        this.generatePdfZips = async (query) => {
            this.cycleCountData = [];
            const result = await api_1.ReportsEndpoint.generatePdfZips.apiCall(null, query);
            if (api_1.isError(result))
                return result.code;
            else
                return `Generating data from ${result.count} order(s).`;
        };
        /** End Query Actions */
        this.loadPatientsReport = async (query = {
            count: 150,
            id: 0,
            patientId: null,
            start: 0
        }) => {
            this.patientReportData = [];
            const result = await api_1.SiteEndpoint.listpatients.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.patientReportData = result.patients;
            }
        };
        // E-037.2
        this.loadPatientReports = async (siteId, logExecution = false) => {
            const result = await api_1.ReportsEndpoint.patientsReports.apiCall(null, {
                siteId: siteId,
                logExecution
            }); // E-037.201
            if (api_1.isError(result)) {
                this.showLoader = false;
                alert("Error");
            }
            else {
                this.showLoader = false;
                this.patientReportData = result.patients;
            }
        };
        /** End Query Actions */
    }
}
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "claimAnalyticsData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "clinicReimbData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "orderAnalyticsData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "salesUsageSummaryData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "negativeBalancesData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "accountsReceivableAgingData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "auditTrailData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "insurancePaymentReportData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "inventoryCountData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "cycleCountData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "reversalsData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "erxData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "networkContactsData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "distributors", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "distibutorAnalyticsData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "dispenseReportData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "transactionCountsData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "certificationsReportData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "requiredAssets", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "editModal", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "showLoader", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "certOptionMissing", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "patientReportData", void 0);
__decorate([
    mobx_1.observable
], ReportsStore.prototype, "patients", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadClaimAnalytics", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadUserAuditTrail", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadClinicReimbursement", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadOrderAnalytics", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadSalesUsage", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadNetworkContacts", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadNegativeBalances", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "repairReversals", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "reportsB2", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadErxReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadClaimErrorReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadMailMessage", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadMailReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadProductAuditReport", void 0);
__decorate([
    mobx_1.action // D-002.911
], ReportsStore.prototype, "loadPatinetPaymentReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadReversalsReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadAccountsReceivableAging", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadTransactionCounts", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadCertificationsReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadRequiredAssets", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadInsurancePaymentReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "getDistributors", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "getDistributorOrderingData", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadDispenseReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadPatientsReport", void 0);
__decorate([
    mobx_1.action
], ReportsStore.prototype, "loadPatientReports", void 0);
exports.reportsStore = new ReportsStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/store.ts
// module id = 64
// module chunks = 0